import React, { useEffect, useState } from "react";
import DateControl from "../../../components/Fields/DateControl";
import DecimalControl from "../../../components/Fields/DecimalControl";
import NumberControl from "../../../components/Fields/NumberControl";
import SelectListControl from "../../../components/Fields/SelectListControl";
import TextboxControl from "../../../components/Fields/TextboxControl";
import { ControlProps } from "../../../components/Fields/Types";
import CodeTaskParameterTypeEnum from "../../../enums/CodeTaskParameterTypeEnum";
import CodeTaskParameterInfo from "../../../models/CodeTaskParameterInfo";

export interface CodeTaskControlProps {
    controlProps: ControlProps
    codeTaskParamterInfo: CodeTaskParameterInfo
    disabled?: boolean
}

const CodeTaskControl: React.FC<CodeTaskControlProps> = ({ controlProps, codeTaskParamterInfo, disabled }) => {
    const [statusTypeId, setStatusTypeId] = useState(0)
    const [statusId, setStatusId] = useState(0)
    const [projectTypeId, setProjectTypeId] = useState(0)
    const [milestoneDefinitionId, setMilestoneDefinitionId] = useState(0)

    useEffect(() => {
        switch (codeTaskParamterInfo.parameterType) {
            case CodeTaskParameterTypeEnum.ItemStatus:
                if (controlProps.value) {
                    setStatusTypeId(() => parseInt(controlProps.value.split(',')[0]));
                    setStatusId(() => parseInt(controlProps.value.split(',')[1]));
                }
            case CodeTaskParameterTypeEnum.MilestoneDefinition:
                if (controlProps.value) {
                    setProjectTypeId(() => parseInt(controlProps.value.split(',')[0]));
                    setMilestoneDefinitionId(() => parseInt(controlProps.value.split(',')[1]));
                }
        }

    }, [controlProps.value, codeTaskParamterInfo.parameterType]);

    function onChangeItemStatus(itemStatusId) {
        setStatusId(() => itemStatusId);
        controlProps.onChange(`${statusTypeId},${itemStatusId}`);
    }

    function onChangeMilestoneDefinition(defintionId) {
        setMilestoneDefinitionId(() => defintionId);
        controlProps.onChange(`${projectTypeId},${defintionId}`);
    }

    switch (codeTaskParamterInfo.parameterType) {
        case CodeTaskParameterTypeEnum.Number:
            return <NumberControl {...controlProps} disabled={disabled} />;

        case CodeTaskParameterTypeEnum.Decimal:
            return <DecimalControl {...controlProps} disabled={disabled} />;

        case CodeTaskParameterTypeEnum.Date:
            return <DateControl {...controlProps} disabled={disabled} />;

        case CodeTaskParameterTypeEnum.ItemStatus:
            return <>
                <SelectListControl name='itemStatusTypeId' onChange={(val) => setStatusTypeId(val)} value={statusTypeId} validationResults={[]} disabled={disabled} optionsUrl='api/v1/selectlist/ItemStatusTypes' nullOption='-- Select item status type' />
                <SelectListControl name='itemStatusId' onChange={(val) => onChangeItemStatus(val)} value={statusId} validationResults={[]} disabled={disabled} optionsUrl={'api/v1/selectlist/ItemStatuses?itemStatusTypeId=' + statusTypeId} nullOption='-- Select item status' />
            </>

        case CodeTaskParameterTypeEnum.UserDefinedField:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/UserDefinedFields' nullOption='-- Select user defined field' />

        case CodeTaskParameterTypeEnum.ProjectStatus:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/ProjectStatuses' nullOption='-- Select project status' />

        case CodeTaskParameterTypeEnum.DesignPhase:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/DesignPhases' nullOption='-- Select design phase' />

        case CodeTaskParameterTypeEnum.Workflow:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/WorkflowDefinitions' nullOption='-- Select workflow' />

        case CodeTaskParameterTypeEnum.FunctionalRole:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/FunctionalRoles' nullOption='-- Select role' />

        case CodeTaskParameterTypeEnum.AttachmentType:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/AttachmentTypes' nullOption='-- Select attachment type' />

        case CodeTaskParameterTypeEnum.GeneratableAttachmentType:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/AttachmentTypesGeneratable' nullOption='-- Select attachment type' />

        case CodeTaskParameterTypeEnum.DocumentOutputType:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/DocumentOutputTypes' nullOption='-- Select document output type' />

        case CodeTaskParameterTypeEnum.DateUserDefinedField:
            return <SelectListControl {...controlProps} disabled={disabled} optionsUrl='api/v1/selectlist/DateUserDefinedFields' nullOption='-- Select user defined field' />

        case CodeTaskParameterTypeEnum.MilestoneDefinition:
            return <>
                <SelectListControl name='projectTypeId' onChange={(val) => setProjectTypeId(val)} value={projectTypeId} validationResults={[]} disabled={disabled} optionsUrl='api/v1/selectlist/ProjectTypes' nullOption='-- Select project type' />
                <SelectListControl name='milestoneDefinitionId' onChange={(val) => onChangeMilestoneDefinition(val)} value={milestoneDefinitionId} validationResults={[]}  disabled={disabled} optionsUrl={'api/v1/selectlist/MilestoneDefinitions?projectTypeId=' + projectTypeId} nullOption='-- Select milestone definition' />
            </>

        default:
            return <TextboxControl {...controlProps} disabled={disabled} />
    }
}
export default CodeTaskControl;